export interface StandardFilterValues {
    age: string | null;
    skinAppearance: string | null;
}

export interface OnlineAnalysisFilterValues {
    ageGroup: string | null;
    skinColour: string | null;
    uvSensitivity: string | null;
    skinAppearance: string | null;
    skinCharacteristics: string[];
}

export interface FilterResult {
    articleNumber: string;
    customerSpecificData: CustomerSpecificData;
    imageUri: string;
    label: string;
    link: string;
    price: string;
    specialPrice: string | null;
    priceInCents: number;
    countryCode: string;
    volume: string;
    skinAppearance: string;
    deliveryNote: string;
    basePrice: string;
    baseQuantity: string;
    usageAdvices: UsageAdviceProp;
    isNew: boolean;
    isDiscounted: boolean;
    isInStock: boolean;
    savingPercent: number | null;
    maxBuyableAmount: number;
    descriptions: ProductDescription[];
    systemCare: ProductSystemCareData;
}

export interface ProductSystemCareData {
    active: boolean;
    position: number;
    activeApplications: ProductApplicationFrequency | null;
    recommendedApplications: ProductApplicationFrequency;
    possibleApplications: number;
}

export interface ProductApplicationFrequency {
    daysPerWeek: number;
    applicationsPerDay: number;
}

export type ProductDescription =
    | MainDescription
    | UsageDescription
    | StorageDescription
    | CleaningAndStorageDescription;

export interface MainDescription {
    nodeType: 'GesagtGetan.Products:Document.AbstractProduct';
    textLeft: string;
    textRight: string;
}
export interface UsageDescription {
    nodeType: 'GesagtGetan.Products:Content.Usage';
    textLeft: string;
    textRight: string;
    usageLeft: string;
    usageRight: string;
}
export interface StorageDescription {
    nodeType: 'GesagtGetan.Products:Content.Storage';
    headlineLeft: string;
    headlineRight: string;
    textLeft: string;
    textRight: string;
}
export interface CleaningAndStorageDescription {
    nodeType: 'GesagtGetan.Products:Content.CleaningAndStorage';
    textLeft: string;
    textRight: string;
}

export interface UsageAdviceProp {
    face: UsageAdviceValue;
    neck: UsageAdviceValue;
    eyes: UsageAdviceValue;
    lips: UsageAdviceValue;
    body: UsageAdviceValue;
}

export type UsageAdviceValue = 'positive' | 'negative' | '';
export enum FilterType {
    customer = 'customer',
    empty = 'empty',
    onlineAnalysis = 'onlineAnalysis',
    skinAnalysis = 'skinAnalysis',
    standardFilter = 'standardFilter',
}

export interface CustomerSpecificData {
    filterType: FilterType;
    hasConsultantNotes: boolean;
    ingredientsContained: string[];
    ingredientsNotContained: string[];
    passesIngredientsCheck: boolean;
    passesSkinCheck: boolean;
    recommendationConsultant: boolean;
    recommendationTextConsultant: string;
    skinAnalysisDate: string | null;
}

interface SkinAnalysisFilter {
    type: 'skinAnalysis';
    skinAnalysisId: string;
}

interface StandardFilter {
    type: 'standardFilter';
    values: StandardFilterValues;
}

interface OnlineAnalysisFilter {
    type: 'onlineAnalysis';
    values: OnlineAnalysisFilterValues;
}

export type Filter = SkinAnalysisFilter | StandardFilter | OnlineAnalysisFilter | null;
